import { Box, Button } from '@packages/shared';
import React, { type ForwardedRef, type ReactNode } from 'react';

export type FilterSettingsDesktopButtonProps = {
  /** Filter that should be rendered within the popover */
  children: ReactNode;
  isActive?: boolean;
  isPopoverOpen?: boolean;
  onClick?: (anchor: HTMLButtonElement) => void;
  large?: boolean;
};

export const FilterSettingsDesktopButton = React.forwardRef(
  (
    { children, isActive, isPopoverOpen, onClick, large }: FilterSettingsDesktopButtonProps,
    ref?: ForwardedRef<HTMLButtonElement | null>,
  ) => {
    const icon = isActive ? (
      <span className="icon-emp-checkmark size-4" />
    ) : (
      <span className="icon-emp-arrow-medium-down size-4" />
    );

    return (
      <Button
        fullWidth
        sx={{
          display: 'flex',
          height: large ? '2.75rem' : '1.25rem',
          paddingRight: 1,
          '& svg': {
            width: '2rem',
            height: '2rem',
          },
        }}
        onClick={(event) => {
          if (event.currentTarget instanceof HTMLButtonElement) {
            onClick?.(event.currentTarget);
            event.stopPropagation();
          }
        }}
        ref={ref}
      >
        <Box
          sx={{
            width: '100%',
            marginRight: 'auto',
            overflow: 'hidden',
            textAlign: 'left',
            hyphens: 'auto',
          }}
        >
          {children}
        </Box>
        {isPopoverOpen ? <span className="icon-emp-cancel size-4" /> : icon}
      </Button>
    );
  },
);
